import Service, { getCallApiFunction } from '../service'

export type ParamsType = {
  roomId: string
}

class SetRoomHiddenApi extends Service {
  constructor({ roomId }: ParamsType) {
    super()
    this.name = 'SET_ROOM_HIDDEN'

    this.config = {
      url: `/v1/livemall/liveroom/launched`,
      method: 'DELETE',
      data: {
        roomId,
      },
    }
  }
}

class UndoRoomHiddenApi extends Service {
  constructor({ roomId }: ParamsType) {
    super()
    this.name = 'UNSET_ROOM_HIDDEN'
    this.config = {
      url: `/v1/livemall/liveroom/launched`,
      method: 'POST',
      data: {
        roomId,
      },
    }
  }
}

export const setRoomHidden = (params: ParamsType) => getCallApiFunction(new SetRoomHiddenApi(params))
export const undoRoomHidden = (params: ParamsType) => getCallApiFunction(new UndoRoomHiddenApi(params))
